import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the password reset),
 * not a state transition (the saga owns the resulting `submit*` transitions).
 */

/**
 * Submit the current draft with the one-time token read from the URL by the
 * page (router param → action payload, mirroring session-detail's
 * `pollStarted(id)`; the token never enters the store).
 */
export const submitRequested = createAction<{ token: string }>('resetPassword/submitRequested');
